var _circle, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4577,
    cy: 10.4577,
    r: 10.4577,
    fill: "#FF0082"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.03329,
    y: 5.74146,
    width: 8.82526,
    height: 8.99831,
    stroke: "#979797",
    strokeOpacity: 0.01,
    strokeWidth: 0.429465
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7416 10.5425L13.8815 10.5425C14.0449 10.5426 14.1776 10.4073 14.1774 10.2407C14.1774 10.074 14.045 9.939 13.8815 9.939L10.7416 9.93903L10.7416 6.73757C10.7416 6.57084 10.6092 6.43584 10.4457 6.43584C10.2823 6.4357 10.1496 6.57099 10.1498 6.73758L10.1497 9.93904L7.00985 9.93907C6.84647 9.93892 6.71378 10.0742 6.71391 10.2408C6.71391 10.3242 6.74712 10.3996 6.8007 10.4542C6.85428 10.5088 6.92808 10.5425 7.00985 10.5425L10.1497 10.5425L10.1497 13.744C10.1497 13.8273 10.1829 13.9027 10.2365 13.9574C10.2901 14.012 10.3639 14.0457 10.4456 14.0457C10.609 14.0458 10.7417 13.9106 10.7416 13.744L10.7416 10.5425",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7416 10.5425L13.8815 10.5425C14.0449 10.5426 14.1776 10.4073 14.1774 10.2407C14.1774 10.074 14.045 9.939 13.8815 9.939L10.7416 9.93903L10.7416 6.73757C10.7416 6.57084 10.6092 6.43584 10.4457 6.43584C10.2823 6.4357 10.1496 6.57099 10.1498 6.73758L10.1497 9.93904L7.00985 9.93907C6.84647 9.93892 6.71378 10.0742 6.71391 10.2408C6.71391 10.3242 6.74712 10.3996 6.8007 10.4542C6.85428 10.5088 6.92808 10.5425 7.00985 10.5425L10.1497 10.5425L10.1497 13.744C10.1497 13.8273 10.1829 13.9027 10.2365 13.9574C10.2901 14.012 10.3639 14.0457 10.4456 14.0457C10.609 14.0458 10.7417 13.9106 10.7416 13.744L10.7416 10.5425",
    stroke: "white",
    strokeWidth: 1.64915
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.0b6c4801be942101c950b567d71d7d42.svg";
export { ForwardRef as ReactComponent };